export default "//static.glanacion.com/v2/ingresar-nuevo/images/user-error.png";